module.exports = __webpack_public_path__ + "img/CompassRose.5cbcc6f7.png";